import { RUNTIME_PROTECTION_CONFIG } from './security.constants';
import { ConsoleSecurityWarningConfig } from './security.types';

export function showConsoleSecurityWarning(
  config: ConsoleSecurityWarningConfig = RUNTIME_PROTECTION_CONFIG.consoleWarning
): void {
  if (!config.enabled) return;

  const titleStyle = config.titleStyle.join(';');
  const messageStyle = config.messageStyle.join(';');
  const linkStyle = config.linkStyle.join(';');

  console.log(
    `%c${config.title}\n%c${config.message}\n%c${config.learnMoreLabel}: ${config.learnMoreUrl}`,
    titleStyle,
    messageStyle,
    linkStyle
  );
}
